import { render } from "./Volunteer.view.vue?vue&type=template&id=4dc0d836"
import script from "./Volunteer.view.vue?vue&type=script&lang=js"
export * from "./Volunteer.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__